module.exports = __webpack_public_path__ + "img/31.acd26322.png";